import { useState } from "react";
import { Snackbar, Button as MuiButton } from "@mui/material";
import { themePalette } from "../../theme";

export interface ToastState {
  open: boolean;
  message: string;
  undoAction?: () => void;
  isError?: boolean;
  autoHideDuration?: number;
}

interface ToastOptions {
  undoAction?: () => void;
  autoHideDuration?: number;
}

export interface Toast {
  state: ToastState;
  showToast: (message: string, options?: ToastOptions) => void;
  showError: (message: string) => void;
  closeToast: () => void;
}

export const useToast = (): Toast => {
  const [state, setState] = useState<ToastState>({ open: false, message: "" });

  return {
    state,
    showToast: (message, options) =>
      setState({ open: true, message, ...options }),
    showError: (message) => setState({ open: true, message, isError: true }),
    closeToast: () => setState({ open: false, message: "" }),
  };
};

export const ActionSnackbar = ({
  state,
  onClose,
}: {
  state: ToastState;
  onClose: () => void;
}): React.ReactElement => (
  <Snackbar
    open={state.open}
    autoHideDuration={state.autoHideDuration ?? 5000}
    onClose={onClose}
    message={state.message}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    ContentProps={{
      sx: state.isError ? { color: themePalette.redMedium } : {},
    }}
    action={
      <>
        {state.undoAction && (
          <MuiButton
            size="small"
            onClick={() => {
              state.undoAction?.();
              onClose();
            }}
            sx={{
              color: themePalette.redMedium,
              fontWeight: 600,
              fontSize: "14px",
              marginLeft: "8px",
              textDecoration: "underline",
              textTransform: "none",
            }}
          >
            Undo
          </MuiButton>
        )}
        <MuiButton
          color="inherit"
          size="small"
          aria-label="Dismiss notification"
          onClick={onClose}
          sx={{ marginLeft: "4px", minWidth: "auto", fontSize: "18px" }}
        >
          ✕
        </MuiButton>
      </>
    }
  />
);
